module.exports = __webpack_public_path__ + "static/img/02450_3.672afa0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/02450_3.jpg
// module id = BvZE
// module chunks = 1